import { render, staticRenderFns } from "./LoadingMore.vue?vue&type=template&id=2e788ff4"
import script from "./LoadingMore.vue?vue&type=script&lang=js"
export * from "./LoadingMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports